export const Marquee = () => {
  const item = (
    <span className="inline-flex items-center">
      <span className="font-display text-5xl sm:text-6xl lg:text-7xl font-light tracking-tight text-[#c9a84c]/25 px-10">
        Premium Accounting.
      </span>
      <span className="text-[#c9a84c]/40 text-3xl">✦</span>
      <span className="font-display text-5xl sm:text-6xl lg:text-7xl font-light italic tracking-tight text-[#c9a84c]/25 px-10">
        Exceptional Results.
      </span>
      <span className="text-[#c9a84c]/40 text-3xl">✦</span>
    </span>
  );

  return (
    <section
      className="relative py-14 border-y border-white/5 bg-[#0c0c12] overflow-hidden"
      data-testid="marquee-section"
      aria-hidden="true"
    >
      <div className="marquee-track">
        {item}
        {item}
        {item}
        {item}
      </div>
    </section>
  );
};
